import { actionHelpers } from 'app-components/flux/core';

// plural
export const getBillerLogins = actionHelpers.createAction('GET_BILLER_LOGINS');
export const getBillerLoginsSuccess = actionHelpers.createAction('GET_BILLER_LOGINS_SUCCESS');
export const getBillerLoginsFailure = actionHelpers.createAction('GET_BILLER_LOGINS_FAILURE');

// singular
export const startRediscovery = actionHelpers.createAction('START_REDISCOVERY');
export const rediscoverBillerLogin = actionHelpers.createAction('REDISCOVER_BILLER_LOGIN');

export const getBillerLogin = actionHelpers.createAction('GET_BILLER_LOGIN');
export const getBillerLoginSuccess = actionHelpers.createAction('GET_BILLER_LOGIN_SUCCESS');
export const getBillerLoginFailure = actionHelpers.createAction('GET_BILLER_LOGIN_FAILURE');

export const updateBillerLogin = actionHelpers.createAction('UPDATE_BILLER_LOGIN');
export const updateBillerLoginSuccess = actionHelpers.createAction('UPDATE_BILLER_LOGIN_SUCCESS');
export const updateBillerLoginFailure = actionHelpers.createAction('UPDATE_BILLER_LOGIN_FAILURE');

export const deleteBillerLogin = actionHelpers.createAction('DELETE_BILLER_LOGIN');
export const deleteBillerLoginSuccess = actionHelpers.createAction('DELETE_BILLER_LOGIN_SUCCESS');
export const deleteBillerLoginFailure = actionHelpers.createAction('DELETE_BILLER_LOGIN_FAILURE');

export const discoverBiller = actionHelpers.createAction('DISCOVER_BILLER');
export const discoverBillerSuccess = actionHelpers.createAction('DISCOVER_BILLER_SUCCESS');
export const discoverBillerFailure = actionHelpers.createAction('DISCOVER_BILLER_FAILURE');

export const addBillerLoginAndAccounts = actionHelpers.createAction('ADD_BILLER_LOGIN_AND_ACCOUNTS');

// This action resets model's biller props and also deletes biller login if it is not used by any other models.
export const resetBillerLoginForModel = actionHelpers.createAction('RESET_BILLER_LOGIN_FOR_MODEL');
